import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import pt from './pt.json';
import ar from './ar.json';
import yo from './yo.json';
import ha from './ha.json';
import ig from './ig.json';
import cy from './cy.json';
import de from './de.json';
import it from './it.json';
import zh from './zh.json';
import hi from './hi.json';
import ja from './ja.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'pt', label: 'Português', flag: '🇧🇷' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  { code: 'zh', label: '简体中文', flag: '🇨🇳' },
  { code: 'hi', label: 'हिन्दी', flag: '🇮🇳' },
  { code: 'ja', label: '日本語', flag: '🇯🇵' },
  { code: 'ar', label: 'العربية', flag: '🇸🇦', rtl: true },
  { code: 'yo', label: 'Yorùbá', flag: '🇳🇬' },
  { code: 'ha', label: 'Hausa', flag: '🇳🇬' },
  { code: 'ig', label: 'Igbo', flag: '🇳🇬' },
  { code: 'cy', label: 'Cymraeg', flag: '🏴󠁧󠁢󠁷󠁬󠁳󠁿' },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
      pt: { translation: pt },
      ar: { translation: ar },
      yo: { translation: yo },
      ha: { translation: ha },
      ig: { translation: ig },
      cy: { translation: cy },
      de: { translation: de },
      it: { translation: it },
      zh: { translation: zh },
      hi: { translation: hi },
      ja: { translation: ja },
    },
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: { order: ['localStorage', 'navigator'], caches: ['localStorage'] },
  });

i18n.on('languageChanged', (lng) => {
  const cfg = SUPPORTED_LANGUAGES.find((l) => l.code === lng);
  document.documentElement.lang = lng;
  document.documentElement.dir = cfg?.rtl ? 'rtl' : 'ltr';
});

// Apply on initial detection too (languageChanged only fires AFTER a change).
// Read the language from localStorage synchronously so the very first paint
// already has the correct dir for RTL locales like Arabic.
const initial = (typeof localStorage !== 'undefined' && localStorage.getItem('i18nextLng'))
  || i18n.language
  || 'en';
const initialCfg = SUPPORTED_LANGUAGES.find((l) => l.code === initial);
if (typeof document !== 'undefined') {
  document.documentElement.lang = initial;
  document.documentElement.dir = initialCfg?.rtl ? 'rtl' : 'ltr';
}

export default i18n;
